const guiColors = {
    'motion-primary': '#ff5726',
    'motion-primary-transparent': '#ff5726e6',
    'motion-tertiary': '#e63e0d',

    'looks-secondary': '#ff5726',
    'looks-secondary-light': '#f7977b',
    'looks-secondary-lighter': '#ffdfd5',
    'looks-transparent': '#ff5d4d59',
    'looks-light-transparent': '#ff5d4d26',
    'looks-secondary-dark': 'hsl(14,55%,55%)',
    'looks-secondary-darker': 'hsl(14,40%,40%)',
    'looks-secondary-deep-dark': 'hsl(16,26%,17%)',

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(10, 85%, 57%, 1)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.43)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#ff9d8a'
};

const blockColors = {
    checkboxActiveBackground: '#ff5726',
    checkboxActiveBorder: '#fc3900'
};

export {
    guiColors,
    blockColors
};